import React from "react";
import "./cookie.css";
import CookieConsent from "react-cookie-consent";
import CookieImg from "../../../../../assets/images/cookie.png";
import { Link } from "react-router-dom";
function Cookie() {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      cookieName="VCT_Technologies_LLC"
      style={{ background: "#282828" }}
      buttonStyle={{
        background: "linear-gradient(96.79deg, #61B350 -0.76%, #2B9651 104%)",
        color: "#fff",
        fontSize: "13px",
        fontfamily: "InterMedium",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "22px",
        color: "#FFFFFF",
        borderRadius: "100px",
        padding: "9px 30px",
      }}
      expires={30}
      enableDeclineButton
      flipButtons
      declineButtonText="Decline"
    >
      {" "}
      <p className="cookie-para">
        <img className="cookieimg" src={CookieImg} />
        Our website uses cookies. By continuing navigating, you consent to our
        use of cookies as detailed in our{" "}
        <Link to="/privacypolicy" className="privpolicy">
          Privacy Policy
        </Link>
        .
      </p>
    </CookieConsent>
  );
}

export default Cookie;
